import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getResumenErroresTarifarios } from '@shared/helpers/api/mantenedores/tarifarios';

/**
 * Hook para manejar el resumen de errores de tarifarios
 */
export const useTarifariosErroresMantenedor = (user, permisos) => {
    const [resumenErrores, setResumenErrores] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const history = useHistory();

    // Cargar resumen de errores
    useEffect(() => {
        const loadResumenErrores = async () => {
            if (!user) return;

            setLoading(true);
            setError(null);

            try {
                const response = await getResumenErroresTarifarios(user);

                if (response.success) {
                    setResumenErrores(response.data);
                } else {
                    setResumenErrores(null);
                    setError(response.error);
                }
            } catch (error) {
                console.error('Error al cargar resumen de errores:', error);
                setResumenErrores(null);
                setError('Error al cargar resumen de errores');
            } finally {
                setLoading(false);
            }
        };

        loadResumenErrores();
    }, [user]);

    const handleViewErrorDetail = (tipoTarifarioId) => {
        history.push(`/mantenedores/tarifarios/errores/${tipoTarifarioId}`);
    };

    const handleViewEmpresaErrorDetail = () => {
        history.push(`/mantenedores/tarifarios/errores/empresa`);
    };

    return {
        resumenErrores,
        loading,
        error,
        handleViewErrorDetail,
        handleViewEmpresaErrorDetail
    };
};
